export {
  getPostTypeLabel,
  getPlainExcerpt,
  formatPostDate,
} from "../Members/memberUtils";

/** Even page size for 2-column grid (prod legacy used 7; Lovable layout needs even count). */
export const EDUCATION_PAGE_SIZE = 6;

export const buildEducationFilter = ({
  educationTopicIds,
  authorIds,
  startDate,
  endDate,
  searchString,
}) => {
  const trimmedSearch = (searchString || "").trim();

  return {
    educationTopicIds: educationTopicIds || [],
    authorIds: authorIds || [],
    tagIds: [],
    educationOnly: true,
    searchString: trimmedSearch,
    ...(trimmedSearch
      ? {
          applySearchStringTo: {
            title: true,
            content: true,
            excerpt: true,
            tags: true,
          },
        }
      : {}),
    publishedAt: {
      from: startDate ? `${startDate} 00:00:00` : null,
      to: endDate ? `${endDate} 23:59:59` : null,
    },
  };
};
